

import { Validators } from '@angular/forms';

import { switchMap, tap } from 'rxjs/operators';

import { Observable, Subscriber } from 'rxjs';

import { CustomFormControlWithField, CustomFormGroup as CustomFormGroupNew } from '@rs-bank/rs-forms-extention';
import {
	Column,
	FieldBoxForCustomFormControl,
	Form,
	Row,
	Section,
} from '@rs-bank/rs-layout';
import { ComponentBox } from '@rs-bank/rs-layout';


import { IbInputmasks } from 'ib/internetbank-core/ib-inputmasks/ib-inputmasks';
import { IbInputField } from 'ib/internetbank-fields/field-types/input.ib.field-types';

import { WizardDataStep } from '../../../../shared/wizard-v2/wizard-core/steps/base-step-types/wizard-data-step';
import { RegistrationProductInformationListComponent } from '../../components/registration-product-information-list/registration-product-information-list.component';
import { BiometricsRegistrationWizardComponent } from '../biometrics-registration-wizard.component';
import { BiomerticsClientData } from '../models/biomertics-client-data';
import { BiometricsRegistrationSecondStepData } from '../models/biometrics-registration-second-step.data';
import { AdditionalCondition, PreloginProduct } from '../models/models';


export class BiometricsRegistrationFirstStep extends WizardDataStep<BiometricsRegistrationWizardComponent> {

	private data: Array<PreloginProduct>;

	public onInit(): Observable<void> {

		this.wizard.options.goBackInvisible = true;

		return this.wizardComponent.biometricsRegistrationWizardService.getLoadedPreloginProducts$$
			.pipe(
				tap((data: Array<PreloginProduct>) => {
					this.data = data;
				}),
				switchMap((data: Array<PreloginProduct>) => this.createInitialForm(data)),
			);
	}

	public override prepareBack(emitEvent: boolean = true): Observable<void> {

		return super.prepareBack(emitEvent)
			.pipe(
				tap(() => {
					this.wizard.options.goBackInvisible = true;
				}),
			);
	}

	public onExecute(): Observable<BiometricsRegistrationSecondStepData> {
		return new Observable((subscriber: Subscriber<BiometricsRegistrationSecondStepData>) => {
			subscriber.next({
				biomerticsClientData: this.newForm?.value,
				preloginProduct: this.data[0],
			});
		});
	}

	public getConditions(): Array<AdditionalCondition> {
		return this.data[0]?.additionalConditions;
	}

	private createInitialForm(data: Array<PreloginProduct>): Observable<void> {
		return new Observable((subscriber: Subscriber<void>) => {

			this.stepInformation.title.next('Заявка на кредит наличными');
			this.stepInformation.setSubmitLabel('Подтвердить');
			this.stepInformation.isAvailableSubmitButton$$.next(true);


			this.newForm = new CustomFormGroupNew<BiomerticsClientData>({
				firstName: new CustomFormControlWithField({}, null, [Validators.required]),
				lastName: new CustomFormControlWithField({}, null, [Validators.required]),
				secondName: new CustomFormControlWithField({}, null),
				phone: new CustomFormControlWithField({}, null, [Validators.required]),
			});

			this.layoutForm = new Form(
				undefined,
				new Column([

					new Section(
						'',
						new Column([
							new Row([
								new Column([
									new Row([
										new ComponentBox(
											RegistrationProductInformationListComponent,
											(componentInstance: RegistrationProductInformationListComponent) => {
												componentInstance.preloginProductList = data;
											},
										),
									]),
								],
								),
							],
								{ cssClassList: ['biometrics-registration-params-row'] },
							),
						]),
						{ cssClassList: ['biometrics-registration-params'] },
					),
					new Section(
						'',
						new Column([
							new Row([
								new FieldBoxForCustomFormControl(
									// eslint-disable-next-line @typescript-eslint/typedef
									(this.newForm as CustomFormGroupNew).getCustomFormControl(c => c.firstName),
									new IbInputField({
										label: 'Имя',
										inputMask: IbInputmasks.ruMask(),
										maxLength: 70,
									}),
									{ cssClassList: ['confirmation-field'] },
								),
								new FieldBoxForCustomFormControl(
									// eslint-disable-next-line @typescript-eslint/typedef
									(this.newForm as CustomFormGroupNew).getCustomFormControl(c => c.secondName),
									new IbInputField({
										label: 'Отчество',
										hints: { underLine: 'Не заполнять при отстутствии' },
										inputMask: IbInputmasks.ruMask(),
										maxLength: 70,
									}),
									{ cssClassList: ['confirmation-field'] },
								),

							]),
							new Row([
								new FieldBoxForCustomFormControl(
									// eslint-disable-next-line @typescript-eslint/typedef
									(this.newForm as CustomFormGroupNew).getCustomFormControl(c => c.lastName),
									new IbInputField({
										label: 'Фамилия',
										inputMask: IbInputmasks.ruMask(),
										maxLength: 70,
									}),
									{ cssClassList: ['confirmation-field'] },
								),
								new FieldBoxForCustomFormControl(
									// eslint-disable-next-line @typescript-eslint/typedef
									(this.newForm as CustomFormGroupNew).getCustomFormControl(c => c.phone),
									new IbInputField({
										label: 'Номер телефона',
										inputMask: IbInputmasks.phone(),
									}),
									{ cssClassList: ['confirmation-field'] },
								),
							]),
						]),
						{ cssClassList: ['biometrics-registration-accounts'] },
					),
				], {
					name: 'biometrics-registration-page',
					cssClassList: ['biometrics-registration-page'],
				}),
				undefined,
			);

			subscriber.next();
		});
	}

}
